import { Component, Input, OnInit } from '@angular/core';
import { SharedDataService } from '../../../services/shared-data.service';
import { Subscription } from 'rxjs';
import { AutoUnsubscribe } from '../../../decorators/auto-unsubscribe';

@Component({
    selector: 'app-currency-component',
    templateUrl: './currency.component.html',
    standalone: false
})
@AutoUnsubscribe('subsArr$')
export class CurrencyComponent implements OnInit {

  @Input() value: number;
  @Input() unitType: string;
  @Input() decimalPlaces: number;
  digitsToTrim: number;
  subsArr$: Subscription[] = [];

  constructor(private _sharedDataService: SharedDataService) {
  }

  ngOnInit(): void {
    this.subsArr$.push(this._sharedDataService.currencyDigitsToTrim$.subscribe(v => {
      this.digitsToTrim = v;
    }))
  }
}
